import { render, staticRenderFns } from "./shipments.vue?vue&type=template&id=329b6ea3&scoped=true&"
import script from "./shipments.vue?vue&type=script&lang=js&"
export * from "./shipments.vue?vue&type=script&lang=js&"
import style0 from "./shipments.vue?vue&type=style&index=0&id=329b6ea3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329b6ea3",
  null
  
)

export default component.exports